var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtpCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.351,
    x2: 0.371,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dffe9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123,
    stopColor: "#6afae5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#186c6f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cube",
    d: "M23.557,29.734V31.77l-2.684,1.156v1.847l-1.148.409V33.421L16,35.033v1.478L17.7,35.9v1.612l3.153-.912v1.832l-4.042.865V37.769L15.982,38v1.478l-.784.165V33.94l8.351-4.222Zm1.568,7.814V39.7l1.738-.252v2.288l1.932-.134V36.762l-3.662.778ZM44.179,48.429v2.217l6.2-1.36v1.761l-6.2,1.816V55.08l9.394-3.42V50.088l-2,.59v-1.69l2.854-.629v4.426L35.166,61.173V55.457l-4.252-1.132V59.49l-2.126-.928v2.421l6.395,3.066L55.174,53.9V46.77L44.179,48.429Zm7.405-9.513v1.69l1.059.149v1.6l.954.055V39.325l-2-.409Zm2.854-2.366v7.39l-2.854.016v1.69l3.605-.275V36.817l-.752-.267Zm-2.854-4.371v3.357l-2.506-.881v3.726l1.326.275V36.9l3.193.9V36.251l-.954-.338V34.3l2.53,1.069V33.948l-3.605-1.777Zm-3.977,1.965V32.179L50.4,33.366V31.589L35.182,24.05,25.125,28.932V33.24l-2.967,1.069v3.868l1.415-.307V35.835l5.214-1.509V31.9l-1.932.692V30.324l8.327-3.42v2.862L30.93,31.141V44.034L25.125,44v2.154l3.662.291v2.421L18.666,47.313v1.675l4.883,1.1v2.036l-4.883-1.47v1.69l2.2.818v1.847L15.99,52.824V51.346l1.706.645V47.163l-.889-.134v3.1l-.833-.252V42.438l2.668-.173v1.69L16.8,43.94v1.541l2.894.236V42.195l2.425-.165V45.9l1.415.118V39.9L15.19,41.07V53.9l11.641,6.053V57.682L22.11,55.567V53.633l6.653,2.476V53.688l-3.662-1.1V50.434l5.8,1.321V46.589l4.252.291V52.6l2.546-.558V44.019l-2.546.016V41.173l9.014.59v2.217l-4.115.031v2.508l5.909-.456V41.9l3.088.2V45.8l1.326-.1V40.4L35.15,38.3V35.442l2.546.527V33.3l4.495,1.258V36.9l5.384,1.132V36.07l-3.411-.951V32.9L37.712,30.63V27.965l8.23,3.491v2.083l1.625.574Zm-7.526,14.89V54.05l-2.352.692v2.665l4.495-1.643V48.712Z",
    transform: "translate(-15.19 -24.05)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtpCube);
export default __webpack_public_path__ + "static/media/extpCube.4dc60cf0c46174422ff5bc572000bf09.svg";
export { ForwardRef as ReactComponent };